<template>
    <admin-layout title="Reports">
        <div class="">
            <DataTable 
            :headers="headers" 
            :count="4">
                <template #body>

                    <template v-for="report in reports" :key="report.key">
                        <tr v-if="report.allowed">
                            <td class="w-11/12 px-6 py-5 text-sm text-gray-900 whitespace-nowrap">
                                <p>{{ report.title }}</p>
                            </td>
                            <td class="text-center">
                                <ActionButton 
                                edit-btn
                                @click="router.push(report.route)"
                                />
                            </td>
                        </tr>
                    </template>
                </template>
            </DataTable>
        </div>

    </admin-layout>
</template>

<script setup lang="ts">
import AdminLayout from '@/layouts/AdminLayout.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';

import { useRouter } from 'vue-router';

const router = useRouter();


const headers: { text: string }[] = [
    { text: 'Label' },
];

const reports = [
    {
        key: "new-member",
        title: "Number of New Members",
        route: "/reports/new-member",
        allowed: window.$hasPermission('view-new-member-reports')
    },
    {
        key: "active-member",
        title: "Number of Active Members",
        route: "/reports/active-member",
        allowed: window.$hasPermission('view-active-member-reports')
    },
    {
        key: "total-member",
        title: "Number of Total Members",
        route: "/reports/total-member",
        allowed: window.$hasPermission('view-total-members')
    },
    {
        key: "booking",
        title: "Number of New Bookings",
        route: "/reports/booking",
        allowed: window.$hasPermission('view-number-of-bookings')
    },
    {
        key: "individual-bookings",
        title: "Individual Patient Bookings",
        route: "/reports/individual-bookings",
        allowed: window.$hasPermission('view-individual-patient-bookings')
    },
    {
        key: "corporate-bookings",
        title: "Corporate Patient Bookings",
        route: "/reports/corporate-bookings",
        allowed: window.$hasPermission('view-corporate-patient-bookings')
    }
];

</script>